/* The site page's sections, each its own address, so any of them can be linked to. Environments has its own tabs inside. */
import { TabRow } from "../../ui/Tabs";

export const SITE_TABS = ["overview", "environments", "feedback", "email", "activity", "settings"] as const;
export type SiteTab = (typeof SITE_TABS)[number];

export const TAB_LABEL: Record<SiteTab, string> = {
  overview: "Overview",
  environments: "Environments",
  feedback: "Feedback",
  email: "Email",
  activity: "Activity",
  settings: "Settings",
};

export function SiteTabs({ href, tabs, current, flags }: { href: (t: SiteTab) => string; tabs: readonly SiteTab[]; current: SiteTab; flags?: Partial<Record<SiteTab, "bad" | "warn">> }) {
  // Something in there needs a look: a small dot in its status color (colored text would read as the brand).
  return <TabRow label="Site sections" current={current} items={tabs.map((t) => ({ id: t, label: TAB_LABEL[t], href: href(t), tone: flags?.[t] }))} />;
}
